function noopLog(...parameters) {
}
function noopLogged(message, value) {
  return value;
}
const noopScopedConsole = Object.freeze({
  log: noopLog,
  logged: noopLogged,
  warn: noopLog,
  warned: noopLogged,
  error: noopLog,
  errored: noopLogged,
  trace: noopLog,
  traced: noopLogged
});
function isNoopScopedConsole(value) {
  return value === noopScopedConsole;
}
export {
  isNoopScopedConsole,
  noopLog,
  noopLogged,
  noopScopedConsole
};
//# sourceMappingURL=Constants.js.map
